import ExecuteQueryTable from "./ExecuteQueryTable";

const ExecuteQuery = () => {
  return (
    <>
      <ExecuteQueryTable />
    </>
  );
};

export default ExecuteQuery;
